(function($) {

    var primaryNavigation = $('#primaryNavigation');
    var siteHeader = $('#siteHeader');

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            siteHeader.removeClass('nav-open');
            $this.addClass('collapsed');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            siteHeader.addClass('nav-open');
            $this.removeClass('collapsed');
        }
    });

}(jQuery));